import { UploadDto } from "../../../autogen/bff-api";

export const uploadImageToS3 = ({
  upload,
  file,
  onProgress,
}: {
  upload: UploadDto;
  file: File;
  onProgress?: (pct: number) => void;
}): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const formData = new FormData();
    formData.append("x-amz-date", upload.renamedXAmzDate);
    formData.append("x-amz-signature", upload.renamedXAmzSignature);
    formData.append("x-amz-algorithm", upload.renamedXAmzAlgorithm);
    formData.append("x-amz-credential", upload.renamedXAmzCredential);
    formData.append("policy", upload.policy);
    formData.append("key", upload.key);
    formData.append("file", file);

    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (e: ProgressEvent) => {
      if (e.lengthComputable) {
        onProgress?.(Math.round((e.loaded / e.total) * 100));
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error("Image upload failed"));
      }
    };

    xhr.onerror = () => {
      reject(new Error("Image upload failed"));
    };

    xhr.onabort = () => {
      reject(new Error("Image upload aborted"));
    };

    xhr.open("POST", upload.url);
    xhr.send(formData);
  });
};
